export const SYSTEM_FONT_FALLBACKS = "'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"

export const FONT_REGULAR = `'BentonSansRegular', ${SYSTEM_FONT_FALLBACKS}`
export const FONT_MEDIUM = `'BentonSansMedium', ${SYSTEM_FONT_FALLBACKS}`
export const FONT_LIGHT = `'BentonSansLight', ${SYSTEM_FONT_FALLBACKS}`
export const FONT_BOOK = `'BentonSansBook', ${SYSTEM_FONT_FALLBACKS}`
export const FONT_BOLD = `'BentonSansBold', ${SYSTEM_FONT_FALLBACKS}`